import React from "react";

export default function WishDateControl({ label, initialValue = "", placeholder = "", required = false, onChange, id, error }) {
  const elementId = id || "txt" + label.replace(" ", "");

  const additionalAttributes = function () {
    var opts = {};
    if (required) {
      opts["required"] = "required";
    }

    return opts;
  };

  return (
    <div className="form-group row">
      <label htmlFor={elementId} className="col-md-3 col-lg-3 col-sm-12 col-form-label">
        {label}
        {required ? <span className="text-danger"> *</span> : null}
      </label>
      <div className="col-lg-9 col-md-9 col-sm-12">
        <input
          type="date"
          id={elementId}
          className={"form-control" + (error ? " is-invalid" : "")}
          name={elementId}
          placeholder={placeholder}
          data-toggle="tooltip"
          data-trigger="hover"
          data-placement="top"
          data-title="Date of birth"
          defaultValue={initialValue}
          onChange={(e) => {
            onChange && onChange(e.target.value);
          }}
          {...additionalAttributes()}
        />
        {error ? <small className="text-danger d-block mt-1">{error}</small> : null}
      </div>
    </div>
  );
}
